<template>
  <el-dialog
    title="选择仓库"
    :visible.sync="callWarehouse.visible"
    width="1100px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <warehouse-list
      class="warehouse"
      type="select"
      :shadow="'never'"
      :call-warehouse="callWarehouse"
      @returnSelectedRowData="returnSelectedRowData"
    />
    <div class="m-t-10 m-b-10 text-c">
      <el-button
        type="primary"
        @click="toSubmit"
      >
        确认
      </el-button>
      <el-button @click="handleClose">
        取消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import WarehouseList from '@/views/my-store/warehouse'

export default {
  name: 'Warehouse',
  components: {
    WarehouseList,
  },
  props: {
    callWarehouse: {
      type: Object,
      default: () => { return { visible: false, warehouseNameLike: '', id: '', warehouseNoLike: '' } },
    },
    placement: {
      type: String,
      default: 'right',
    },
  },

  data () {
    return {
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    returnSelectedRowData (data) {
      this.selectedRowData = data
    },
    toSubmit () {
      if (!this.selectedRowData) {
        this.$message.error('请先选择仓库')
        return
      }
      this.$emit('returnWarehouseData', this.selectedRowData)
      this.handleClose()
    },
    handleClose () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.warehouse {
  max-height: 500px;
  overflow-y: auto;
}
</style>
